import { connect } from 'react-redux';
import { setState } from '@jvitela/recompute';
import { period as periodParser } from '@gisatcz/ptr-utils';
import mapTimelineSelectors from '../../../state/Timeline/MapTimeline/selectors';
import periodsSelectors from '../../../state/Periods/selectors';

var getParsedPeriod = function getParsedPeriod(period) {
  var _period$data, _period$data2, _period$data3;

  if (period !== null && period !== void 0 && (_period$data = period.data) !== null && _period$data !== void 0 && _period$data.start && period !== null && period !== void 0 && (_period$data2 = period.data) !== null && _period$data2 !== void 0 && _period$data2.end) {
    var parsed = periodParser.parse("".concat(period.data.start, "/").concat(period.data.end));
    return {
      start: parsed.start,
      end: parsed.end
    };
  } else if (period !== null && period !== void 0 && (_period$data3 = period.data) !== null && _period$data3 !== void 0 && _period$data3.period) {
    var _parsed = periodParser.parse(period.data.period);

    return {
      start: _parsed.start.toString(),
      end: _parsed.end.toString()
    };
  } else {
    return null;
  }
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$originPerio, _ownProps$originPerio2;

  setState(state);
  var parsedPeriod = null;

  if (ownProps !== null && ownProps !== void 0 && (_ownProps$originPerio = ownProps.originPeriod) !== null && _ownProps$originPerio !== void 0 && _ownProps$originPerio.key && !(ownProps !== null && ownProps !== void 0 && (_ownProps$originPerio2 = ownProps.originPeriod) !== null && _ownProps$originPerio2 !== void 0 && _ownProps$originPerio2.data)) {
    parsedPeriod = periodsSelectors.getByKey(state, ownProps.originPeriod.key);
  } else {
    parsedPeriod = ownProps.originPeriod;
  }

  parsedPeriod = getParsedPeriod(parsedPeriod);
  var active = mapTimelineSelectors.getTimelineLayerPeriodActive(ownProps.mapKey, ownProps.layer, ownProps.originPeriod);
  return {
    parsedPeriod: parsedPeriod,
    active: active
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {
    onMount: function onMount() {}
  };
};

export default connect(mapStateToProps, mapDispatchToProps);